var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { staticClass: "pt-0" },
        [
          !["AccountGroupsCreate", "AccountGroupsUpdate"].includes(
            _vm.$route.name
          ) &&
          (_vm.loadingDetail || _vm.loadingMembers)
            ? _c("skeleton-groups")
            : [
                _c(
                  "v-col",
                  { staticClass: "px-0", staticStyle: { "z-index": "0" } },
                  [
                    _c("div", { staticClass: "mt-0 pa-0 d-flex" }, [
                      _c(
                        "div",
                        {
                          staticClass: "pa-0",
                          staticStyle: { flex: "0", "min-width": "350px" },
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { position: "fixed!important" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "pa-0 pb-16",
                                  attrs: {
                                    flat: "",
                                    width: "350",
                                    height: "calc(100vh - 220px)",
                                  },
                                },
                                [
                                  _c(
                                    "v-toolbar",
                                    {
                                      attrs: {
                                        color: "transparent",
                                        flat: "",
                                        height: "46",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-toolbar-title",
                                        {
                                          staticClass:
                                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              attrs: {
                                                align: "center",
                                                "no-gutters": "",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    size: "18",
                                                    left: "",
                                                    color: "grey-700",
                                                  },
                                                },
                                                [_vm._v("mdi-account-group")]
                                              ),
                                              _vm._v(" Rol "),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("v-divider"),
                                  _c(
                                    "v-card-text",
                                    {
                                      staticClass: "pa-0",
                                      staticStyle: {
                                        "min-height": "calc(100vh - 420px)",
                                      },
                                    },
                                    [
                                      _vm.currentStep === "inf"
                                        ? [
                                            _vm.loadingDetail
                                              ? _c("skeleton-groups", {
                                                  staticClass: "mt-5",
                                                  attrs: { type: "inf" },
                                                })
                                              : _c(
                                                  "v-list",
                                                  {
                                                    staticClass:
                                                      "transparent py-2 px-5",
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item",
                                                      [
                                                        _c(
                                                          "v-list-item-content",
                                                          [
                                                            _c(
                                                              "v-list-item-title",
                                                              [_vm._v("Nombre")]
                                                            ),
                                                            _c(
                                                              "v-list-item-subtitle",
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      error:
                                                                        _vm.$v
                                                                          .name
                                                                          .$error,
                                                                      disabled:
                                                                        _vm
                                                                          .$route
                                                                          .name !==
                                                                        "AccountGroupsCreate"
                                                                          ? !_vm.$helpers.hasPermission(
                                                                              [
                                                                                "change_group",
                                                                              ]
                                                                            )
                                                                          : false,
                                                                      outlined:
                                                                        "",
                                                                      "single-line":
                                                                        "",
                                                                      dense: "",
                                                                      "hide-details":
                                                                        "",
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.isChangeName = true
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.$v
                                                                          .name
                                                                          .$model,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .$v
                                                                              .name,
                                                                            "$model",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "$v.name.$model",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-list-item",
                                                      { staticClass: "mt-0" },
                                                      [
                                                        _c(
                                                          "v-list-item-content",
                                                          [
                                                            _c(
                                                              "v-list-item-title",
                                                              {
                                                                staticClass:
                                                                  "align-self-start",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Descripción"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-list-item-subtitle",
                                                              [
                                                                _c(
                                                                  "v-textarea",
                                                                  {
                                                                    staticClass:
                                                                      "textarea-users mt-1",
                                                                    attrs: {
                                                                      error:
                                                                        _vm.$v
                                                                          .description
                                                                          .$error,
                                                                      height: 90,
                                                                      disabled:
                                                                        _vm
                                                                          .$route
                                                                          .name !==
                                                                        "AccountGroupsCreate"
                                                                          ? !_vm.$helpers.hasPermission(
                                                                              [
                                                                                "change_group",
                                                                              ]
                                                                            )
                                                                          : false,
                                                                      outlined:
                                                                        "",
                                                                      "single-line":
                                                                        "",
                                                                      dense: "",
                                                                      hint: "(Máximo 150 caracteres)",
                                                                      "persistent-hint":
                                                                        "",
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.isChangeDescription = true
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.$v
                                                                          .description
                                                                          .$model,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .$v
                                                                              .description,
                                                                            "$model",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "$v.description.$model",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm.$route.name === "AccountGroupsUpdate"
                                    ? [
                                        _c("v-divider", {
                                          staticClass: "mx-6",
                                          class: { "mt-n7": _vm.loadingDetail },
                                        }),
                                        _c(
                                          "v-card-actions",
                                          {
                                            staticClass: "px-5 pt-5",
                                            staticStyle: { display: "block" },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "d-block body-1 grey-300--text",
                                              },
                                              [
                                                _vm._v(
                                                  " Al eliminar el rol, todos los usuarios pertenecientes a este quedarán sin permisos activos. "
                                                ),
                                              ]
                                            ),
                                            _vm.$helpers.hasPermission([
                                              "delete_member",
                                            ])
                                              ? _c(
                                                  "v-btn",
                                                  {
                                                    staticStyle: {
                                                      border:
                                                        "1px solid var(--light-red-500) !important",
                                                    },
                                                    attrs: { outlined: "" },
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.dialogDelete = true
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "red-500--text",
                                                      },
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticStyle: {
                                                              color:
                                                                "var(--light-red-500) !important",
                                                            },
                                                          },
                                                          [_vm._v("mdi-delete")]
                                                        ),
                                                        _vm._v(
                                                          " Eliminar rol "
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "pa-0 pb-16 ml-8",
                          staticStyle: { flex: "1", "min-width": "350px" },
                        },
                        [
                          _c(
                            "v-toolbar",
                            {
                              attrs: {
                                color: "transparent",
                                flat: "",
                                height: "46",
                              },
                            },
                            [
                              _c(
                                "v-toolbar-title",
                                {
                                  staticClass:
                                    "subtitle-1 grey-700--text font-weight-semibold",
                                },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        align: "center",
                                        "no-gutters": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            size: "18",
                                            left: "",
                                            color: "grey-700",
                                          },
                                        },
                                        [_vm._v("mdi-lock")]
                                      ),
                                      _vm._v(" Permisos del rol "),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("v-spacer"),
                              _c(
                                "v-toolbar-items",
                                [
                                  _vm.$route.name === "AccountGroupsUpdate"
                                    ? _c(
                                        "v-row",
                                        {
                                          staticClass: "mr-3",
                                          attrs: {
                                            align: "center",
                                            justify: "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { outlined: "" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.dialogUsers = true
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { left: "" } },
                                                [_vm._v("mdi-account-group")]
                                              ),
                                              _vm._v(" Lista de usuarios "),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.loadingDetail
                            ? _c(
                                "v-col",
                                { staticClass: "pa-0" },
                                [
                                  _c("v-skeleton-loader", {
                                    staticClass: "skeleton-group rounded-t-md",
                                    attrs: {
                                      tile: "",
                                      transition: "fade-transition",
                                      type: "image",
                                      height: 200,
                                    },
                                  }),
                                  _c("v-divider"),
                                  _c("v-skeleton-loader", {
                                    staticClass: "skeleton-group",
                                    attrs: {
                                      tile: "",
                                      transition: "fade-transition",
                                      type: "image",
                                      height: 200,
                                    },
                                  }),
                                  _c("v-divider"),
                                  _c("v-skeleton-loader", {
                                    staticClass: "skeleton-group rounded-b-md",
                                    attrs: {
                                      tile: "",
                                      transition: "fade-transition",
                                      type: "image",
                                      height: 200,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "v-row",
                                {
                                  staticClass: "fill-height mt-2",
                                  attrs: { align: "start", "no-gutters": "" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "px-0" },
                                    _vm._l(_vm.list, function (item, i) {
                                      return _c(
                                        "v-card",
                                        {
                                          key: i,
                                          staticClass: "pa-0",
                                          class: item.parent
                                            ? _vm.roundedByCategory(
                                                item.category
                                              )
                                            : "my-5",
                                          attrs: { flat: "" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              item.parent ===
                                                "Configuraciones" &&
                                              item.category === "Organización"
                                                ? [
                                                    _c(
                                                      "v-toolbar",
                                                      {
                                                        attrs: {
                                                          color: "transparent",
                                                          flat: "",
                                                          height: "46",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-toolbar-title",
                                                          {
                                                            staticClass:
                                                              "px-5 subtitle-2 grey-700--text font-weight-semibold",
                                                          },
                                                          [
                                                            _c(
                                                              "v-row",
                                                              {
                                                                attrs: {
                                                                  align:
                                                                    "center",
                                                                  "no-gutters":
                                                                    "",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      size: "18",
                                                                      left: "",
                                                                      color:
                                                                        "grey-700",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-file-document"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  " Configuración "
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c("v-divider"),
                                                  ]
                                                : _vm._e(),
                                              _c(
                                                "v-toolbar",
                                                {
                                                  attrs: {
                                                    color: "transparent",
                                                    flat: "",
                                                    height: "46",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-toolbar-title",
                                                    {
                                                      staticClass:
                                                        "px-5 subtitle-2 grey-700--text font-weight-semibold",
                                                    },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                            "no-gutters": "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                size: "18",
                                                                left: "",
                                                                color:
                                                                  "grey-700",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-" +
                                                                  _vm._s(
                                                                    item.icon
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                item.category ===
                                                                  "SII"
                                                                  ? _vm.$t(
                                                                      "generals.SII"
                                                                    )
                                                                  : item.category
                                                              ) +
                                                              " "
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c("v-divider"),
                                              _c(
                                                "v-card-text",
                                                { staticClass: "pa-0" },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { staticClass: "px-5" },
                                                    [
                                                      _vm.loadingDetail
                                                        ? _c(
                                                            "skeleton-groups",
                                                            {
                                                              attrs: {
                                                                type: "permissions",
                                                              },
                                                            }
                                                          )
                                                        : _vm._l(
                                                            item.children,
                                                            function (
                                                              c,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "v-col",
                                                                {
                                                                  key: index,
                                                                  staticClass:
                                                                    "pa-0",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-list",
                                                                    {
                                                                      staticClass:
                                                                        "v-list-1 transparent pa-0",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item",
                                                                        {
                                                                          staticClass:
                                                                            "pa-0",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-list-item-title",
                                                                            {
                                                                              staticClass:
                                                                                "grey-300--text",
                                                                            },
                                                                            [
                                                                              c.key !==
                                                                              "dtes"
                                                                                ? _c(
                                                                                    "span",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          c.name
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                              [
                                                                                "Resúmenes",
                                                                                "Emisión por lotes",
                                                                                "Cuadratura",
                                                                                "Clientes",
                                                                              ].includes(
                                                                                c.category
                                                                              )
                                                                                ? [
                                                                                    c.name.includes(
                                                                                      "Ver"
                                                                                    ) &&
                                                                                    item
                                                                                      ?.children[
                                                                                      index -
                                                                                        1
                                                                                    ]
                                                                                      ?.active
                                                                                      ? _c(
                                                                                          "v-chip",
                                                                                          {
                                                                                            staticClass:
                                                                                              "caption pa-2 ml-1",
                                                                                            attrs:
                                                                                              {
                                                                                                color:
                                                                                                  "blue-50",
                                                                                                "text-color":
                                                                                                  "blue-200",
                                                                                                "x-small":
                                                                                                  "",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                class:
                                                                                                  {
                                                                                                    "d-inline-block text-truncate":
                                                                                                      _vm
                                                                                                        .$vuetify
                                                                                                        .breakpoint
                                                                                                        .width <
                                                                                                      1310,
                                                                                                  },
                                                                                                style: `max-width: ${
                                                                                                  _vm
                                                                                                    .$vuetify
                                                                                                    .breakpoint
                                                                                                    .width <
                                                                                                  1310
                                                                                                    ? "300px"
                                                                                                    : "auto"
                                                                                                };`,
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  " Obligatorio, si la opción " +
                                                                                                    _vm._s(
                                                                                                      item.children[
                                                                                                        index -
                                                                                                          1
                                                                                                      ].name.toLowerCase()
                                                                                                    ) +
                                                                                                    " está activa "
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                  ]
                                                                                : _vm._e(),
                                                                              c.id ===
                                                                              "add_document"
                                                                                ? [
                                                                                    _vm.selectOrDeselectAllPermission ||
                                                                                    !!_vm.currentDocumentList.filter(
                                                                                      (
                                                                                        item
                                                                                      ) =>
                                                                                        item[
                                                                                          `${item.id}__add_document`
                                                                                        ]
                                                                                    )
                                                                                      .length
                                                                                      ? _c(
                                                                                          "v-tooltip",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                color:
                                                                                                  "grey-background",
                                                                                                right:
                                                                                                  "",
                                                                                                "max-width":
                                                                                                  "185px",
                                                                                                transition:
                                                                                                  "scale-transition",
                                                                                              },
                                                                                            scopedSlots:
                                                                                              _vm._u(
                                                                                                [
                                                                                                  {
                                                                                                    key: "activator",
                                                                                                    fn: function ({
                                                                                                      on,
                                                                                                    }) {
                                                                                                      return [
                                                                                                        _c(
                                                                                                          "span",
                                                                                                          _vm._g(
                                                                                                            {},
                                                                                                            on
                                                                                                          ),
                                                                                                          [
                                                                                                            _c(
                                                                                                              "v-icon",
                                                                                                              {
                                                                                                                staticClass:
                                                                                                                  "ml-2",
                                                                                                                attrs:
                                                                                                                  {
                                                                                                                    small:
                                                                                                                      "",
                                                                                                                    color:
                                                                                                                      "grey-500",
                                                                                                                  },
                                                                                                              },
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  "mdi-information"
                                                                                                                ),
                                                                                                              ]
                                                                                                            ),
                                                                                                          ],
                                                                                                          1
                                                                                                        ),
                                                                                                      ]
                                                                                                    },
                                                                                                  },
                                                                                                ],
                                                                                                null,
                                                                                                true
                                                                                              ),
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "span",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "d-block px-3 py-2",
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  " También se habilitará el permiso de ver emisión"
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                          ]
                                                                                        )
                                                                                      : _vm._e(),
                                                                                  ]
                                                                                : _vm._e(),
                                                                            ],
                                                                            2
                                                                          ),
                                                                          _c(
                                                                            "v-list-item-subtitle",
                                                                            [
                                                                              c.key !==
                                                                              "dtes"
                                                                                ? _c(
                                                                                    "v-switch",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mt-n1",
                                                                                      attrs:
                                                                                        {
                                                                                          color:
                                                                                            "success",
                                                                                          ripple: false,
                                                                                          "hide-details":
                                                                                            "",
                                                                                          disabled:
                                                                                            item
                                                                                              .children[
                                                                                              index -
                                                                                                1
                                                                                            ]
                                                                                              ?.active,
                                                                                        },
                                                                                      on: {
                                                                                        change:
                                                                                          function (
                                                                                            $event
                                                                                          ) {
                                                                                            return _vm.handlerChange(
                                                                                              c,
                                                                                              item
                                                                                            )
                                                                                          },
                                                                                      },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            c.active,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                c,
                                                                                                "active",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "c.active",
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : _vm._e(),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      c.key ===
                                                                      "dtes"
                                                                        ? _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "mt-n7",
                                                                            },
                                                                            [
                                                                              _vm._l(
                                                                                _vm.currentDocumentList,
                                                                                function (
                                                                                  doc,
                                                                                  i
                                                                                ) {
                                                                                  return _c(
                                                                                    "v-list-item",
                                                                                    {
                                                                                      key: i,
                                                                                      staticClass:
                                                                                        "pa-0",
                                                                                      attrs:
                                                                                        {
                                                                                          inactive:
                                                                                            "",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "v-list-item-title",
                                                                                        {
                                                                                          staticClass:
                                                                                            "grey-300--text",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              doc.name
                                                                                            ) +
                                                                                              " "
                                                                                          ),
                                                                                          doc.name.includes(
                                                                                            "Ver"
                                                                                          ) &&
                                                                                          _vm
                                                                                            .currentDocumentList[
                                                                                            i -
                                                                                              1
                                                                                          ]
                                                                                            .active
                                                                                            ? _c(
                                                                                                "v-chip",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "caption pa-2 ml-1",
                                                                                                  attrs:
                                                                                                    {
                                                                                                      color:
                                                                                                        "blue-50",
                                                                                                      "text-color":
                                                                                                        "blue-200",
                                                                                                      "x-small":
                                                                                                        "",
                                                                                                    },
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "span",
                                                                                                    {
                                                                                                      class:
                                                                                                        {
                                                                                                          "d-inline-block text-truncate":
                                                                                                            _vm
                                                                                                              .$vuetify
                                                                                                              .breakpoint
                                                                                                              .width <
                                                                                                            1310,
                                                                                                        },
                                                                                                      style: `max-width: ${
                                                                                                        _vm
                                                                                                          .$vuetify
                                                                                                          .breakpoint
                                                                                                          .width <
                                                                                                        1310
                                                                                                          ? "300px"
                                                                                                          : "auto"
                                                                                                      };`,
                                                                                                    },
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        " Obligatorio, si la opción " +
                                                                                                          _vm._s(
                                                                                                            _vm.currentDocumentList[
                                                                                                              i -
                                                                                                                1
                                                                                                            ].name.toLowerCase()
                                                                                                          ) +
                                                                                                          " está activa "
                                                                                                      ),
                                                                                                    ]
                                                                                                  ),
                                                                                                ]
                                                                                              )
                                                                                            : _vm._e(),
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                      _c(
                                                                                        "v-list-item-subtitle",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mr-0",
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "v-switch",
                                                                                            {
                                                                                              staticClass:
                                                                                                "mt-n1",
                                                                                              attrs:
                                                                                                {
                                                                                                  color:
                                                                                                    "green-500",
                                                                                                  ripple: false,
                                                                                                  disabled:
                                                                                                    doc.name.includes(
                                                                                                      "Ver"
                                                                                                    ) &&
                                                                                                    _vm
                                                                                                      .currentDocumentList[
                                                                                                      i -
                                                                                                        1
                                                                                                    ]
                                                                                                      .active,
                                                                                                  "hide-details":
                                                                                                    "",
                                                                                                },
                                                                                              on: {
                                                                                                click:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    _vm.enabledTooltip(
                                                                                                      doc,
                                                                                                      i,
                                                                                                      index
                                                                                                    ),
                                                                                                      (item.selectOrDeselectAllPermission =
                                                                                                        _vm.currentDocumentList.every(
                                                                                                          (
                                                                                                            item
                                                                                                          ) =>
                                                                                                            item.active
                                                                                                        ))
                                                                                                  },
                                                                                                change:
                                                                                                  function (
                                                                                                    $event
                                                                                                  ) {
                                                                                                    _vm.isChangeList = true
                                                                                                  },
                                                                                              },
                                                                                              model:
                                                                                                {
                                                                                                  value:
                                                                                                    doc.active,
                                                                                                  callback:
                                                                                                    function (
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.$set(
                                                                                                        doc,
                                                                                                        "active",
                                                                                                        $$v
                                                                                                      )
                                                                                                    },
                                                                                                  expression:
                                                                                                    "doc.active",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                }
                                                                              ),
                                                                              item.category ===
                                                                              "Emisión"
                                                                                ? _c(
                                                                                    "v-col",
                                                                                    {
                                                                                      class:
                                                                                        [
                                                                                          "pa-0 mt-2",
                                                                                          {
                                                                                            "mb-6":
                                                                                              _vm
                                                                                                .$store
                                                                                                .state
                                                                                                .auth
                                                                                                .account
                                                                                                .country !==
                                                                                              "PE",
                                                                                          },
                                                                                        ],
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "v-list",
                                                                                        {
                                                                                          staticClass:
                                                                                            "v-list-1 transparent pa-0",
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "v-list-item",
                                                                                            {
                                                                                              staticClass:
                                                                                                "pa-0",
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "v-list-item-title",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "font-weight-bold grey-300--text",
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "Seleccionar todos los DTE’s"
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                              _c(
                                                                                                "v-list-item-subtitle",
                                                                                                [
                                                                                                  _c(
                                                                                                    "v-switch",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "mt-n1",
                                                                                                      attrs:
                                                                                                        {
                                                                                                          color:
                                                                                                            "green-500",
                                                                                                          ripple: false,
                                                                                                          "hide-details":
                                                                                                            "",
                                                                                                        },
                                                                                                      on: {
                                                                                                        change:
                                                                                                          function (
                                                                                                            $event
                                                                                                          ) {
                                                                                                            ;(_vm.isChangeList = true),
                                                                                                              _vm.selectAllPermissions(
                                                                                                                item.category,
                                                                                                                $event
                                                                                                              )
                                                                                                          },
                                                                                                      },
                                                                                                      model:
                                                                                                        {
                                                                                                          value:
                                                                                                            item.selectOrDeselectAllPermission,
                                                                                                          callback:
                                                                                                            function (
                                                                                                              $$v
                                                                                                            ) {
                                                                                                              _vm.$set(
                                                                                                                item,
                                                                                                                "selectOrDeselectAllPermission",
                                                                                                                $$v
                                                                                                              )
                                                                                                            },
                                                                                                          expression:
                                                                                                            "item.selectOrDeselectAllPermission",
                                                                                                        },
                                                                                                    }
                                                                                                  ),
                                                                                                ],
                                                                                                1
                                                                                              ),
                                                                                            ],
                                                                                            1
                                                                                          ),
                                                                                        ],
                                                                                        1
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                : _vm._e(),
                                                                              _vm
                                                                                .$store
                                                                                .state
                                                                                .auth
                                                                                .account
                                                                                .country !==
                                                                              "PE"
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mt-n3",
                                                                                      staticStyle:
                                                                                        {
                                                                                          "border-top":
                                                                                            "1px solid var(--light-grey-50)",
                                                                                          position:
                                                                                            "absolute",
                                                                                          width:
                                                                                            "100%",
                                                                                          left: "0",
                                                                                          right:
                                                                                            "0",
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : _vm._e(),
                                                                            ],
                                                                            2
                                                                          )
                                                                        : _vm._e(),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                    ],
                                                    2
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm.list.length - 1 !== i &&
                                              (["Configuraciones"].includes(
                                                item.parent
                                              ) ||
                                                [
                                                  "Documentos",
                                                  "Emisión",
                                                  "Emisión por lotes",
                                                  "Cuadratura",
                                                  "Resúmenes",
                                                  "Clientes",
                                                ].includes(item.category))
                                                ? _c("v-divider")
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ],
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass:
            "text-end grey-background mt-6 pa-0 pagination-permissions",
        },
        [
          _c("v-divider"),
          _c(
            "v-col",
            { staticClass: "px-0" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "px-4",
                  attrs: {
                    to: { name: "AccountGroups", params: this.$route.params },
                    outlined: "",
                  },
                },
                [_vm._v("Cancelar")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "px-4 ml-2 mr-6",
                  attrs: {
                    loading:
                      _vm.$route.name === "AccountGroupsCreate"
                        ? _vm.loading
                        : _vm.loadingUpdate,
                    disabled:
                      !_vm.isChangeName &&
                      !_vm.isChangeDescription &&
                      !_vm.isChangeList,
                    color: "grey-900",
                  },
                  on: {
                    click: function ($event) {
                      _vm.$route.name === "AccountGroupsCreate"
                        ? _vm.create()
                        : _vm.update()
                    },
                  },
                },
                [_vm._v(" Guardar rol ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "751",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogDelete,
            callback: function ($$v) {
              _vm.dialogDelete = $$v
            },
            expression: "dialogDelete",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "transparent", flat: "", height: "46" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Eliminar rol")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogDelete = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-5 grey-500--text" },
                [
                  _c(
                    "v-row",
                    { attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "3" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/backgrounds/modal-document-confirm.svg`),
                            width: 148,
                          },
                        }),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pr-4 pl-0" },
                        [
                          _c("span", { staticClass: "d-block" }, [
                            _vm._v(
                              "Al eliminar el rol, todos los usuarios pertenecientes a este quedarán sin permisos activos."
                            ),
                          ]),
                          _c("span", { staticClass: "d-block mt-4 mb-3" }, [
                            _vm._v("Escribe "),
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v("“confirmar”"),
                            ]),
                            _vm._v(" para continuar."),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "single-line": "",
                              maxlength: "9",
                              dense: "",
                              "hide-details": "",
                            },
                            model: {
                              value: _vm.confirm,
                              callback: function ($$v) {
                                _vm.confirm = $$v
                              },
                              expression: "confirm",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogDelete = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        disabled: _vm.confirm.toLowerCase() !== "confirmar",
                      },
                      on: { click: _vm.destroyGroup },
                    },
                    [_vm._v("Confirmar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "600",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
            scrollable: true,
          },
          model: {
            value: _vm.dialogUsers,
            callback: function ($$v) {
              _vm.dialogUsers = $$v
            },
            expression: "dialogUsers",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { color: "transparent", flat: "", height: "46" } },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-500--text font-weight-semibold",
                        },
                        [_vm._v("Lista de usuarios")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: { click: _vm.handlerUserDialog },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                {
                  class: [
                    "pa-0 grey-500--text aling-center",
                    { "d-flex": !_vm.currentMembersList?.length },
                  ],
                },
                [
                  _vm.loadingMembers
                    ? _c("skeleton-list")
                    : [
                        _vm.currentMembersList?.length
                          ? _c("v-data-table", {
                              staticClass: "users-table",
                              attrs: {
                                headers: _vm.headers,
                                items: _vm.currentMembersList,
                                "hide-default-header": "",
                                "items-per-page":
                                  _vm.currentMembersList?.length,
                                "disable-sort": "",
                                "fixed-header": "",
                                height: "450",
                                "hide-default-footer": "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function ({ props: { headers } }) {
                                      return [
                                        _c("VTableHeaders", {
                                          attrs: { headers: headers },
                                          on: {
                                            sort: function ($event) {
                                              return _vm.soting()
                                            },
                                          },
                                        }),
                                        _c("v-divider", {
                                          staticStyle: {
                                            position: "absolute",
                                            "margin-top": "-6px",
                                            "min-width": "100%",
                                            "margin-left": "-5px",
                                            "z-index": "2",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.first_name`,
                                    fn: function ({ item }) {
                                      return [
                                        item.first_name || item.last_name
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "fotn-weight-medium body-1 d-inline-block text-truncate",
                                                staticStyle: {
                                                  "max-width": "96%",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.first_name) +
                                                    " " +
                                                    _vm._s(item.last_name)
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-1 text--disabled font-italic",
                                              },
                                              [_vm._v("Sin especificar")]
                                            ),
                                        item.email
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "d-block body-1 grey-300--text body-users",
                                              },
                                              [_vm._v(_vm._s(item.email))]
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.joined_at`,
                                    fn: function ({ item }) {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("dateTime")(item.joined_at)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: `item.actions`,
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              text: "",
                                              color: "grey-900",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.$router.replace({
                                                  name: "AccountMemberUpdate",
                                                  params: { id: item.id },
                                                })
                                              },
                                            },
                                          },
                                          [_vm._v("Ir al usuario")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          : _c("v-empty-state", {
                              staticClass: "my-16",
                              attrs: {
                                type: "users",
                                id: "miembros",
                                isFree: true,
                                title: "No existen usuarios",
                                height: 180,
                                customClass: "mt-5",
                              },
                            }),
                      ],
                ],
                2
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _vm.currentMembersList.length
                    ? _c(
                        "v-btn",
                        {
                          attrs: { outlined: "" },
                          on: {
                            click: function ($event) {
                              _vm.dialogExport = true
                            },
                          },
                        },
                        [_vm._v("Descargar listado")]
                      )
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey-900" },
                      on: { click: _vm.handlerUserDialog },
                    },
                    [_vm._v("Aceptar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "439",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogExport,
            callback: function ($$v) {
              _vm.dialogExport = $$v
            },
            expression: "dialogExport",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [_vm._v("Descarga listado")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.dialogExport = false),
                                        (_vm.type = "")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: "grey-300--text",
                                        size: "20",
                                      },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 py-2" },
                [
                  _c(
                    "v-list",
                    { staticClass: "pa-0 transparent" },
                    [
                      _c(
                        "v-list-item",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "v-list-item-content",
                            { staticClass: "pt-0" },
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "grey-700--text body-1 font-weight-medium",
                                },
                                [
                                  _vm._v(
                                    "Selecciona el formato de los archivos:"
                                  ),
                                ]
                              ),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "mt-n1" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-sm-space-between",
                                    },
                                    _vm._l(_vm.fileFormat, function (file) {
                                      return _c(
                                        "div",
                                        { key: file, staticClass: "pa-0" },
                                        [
                                          _c(
                                            "v-radio-group",
                                            {
                                              attrs: {
                                                dense: "",
                                                "hide-details": "",
                                              },
                                              model: {
                                                value: _vm.type,
                                                callback: function ($$v) {
                                                  _vm.type = $$v
                                                },
                                                expression: "type",
                                              },
                                            },
                                            [
                                              _c("v-radio", {
                                                attrs: {
                                                  label: file,
                                                  value: file,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", ripple: false },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialogExport = false), (_vm.type = "")
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        ripple: false,
                        disabled: !_vm.type.length,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.createExport()
                        },
                      },
                    },
                    [_vm._v("Descargar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }